import React from "react";
import { ActionCreators as UndoActionCreators } from "redux-undo";
import { connect } from "react-redux";
import * as actionTypes from "../../../store/Actions/actions";

class UndoRedo extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    //
  }
  componentDidUpdate() {
    //
  }
  render() {
    return (
      <div className="undoRedo tenth-step tool-bar-button">
        <div>
          {" "}
          <button
            className="undo"
            onClick={this.props.onUndo}
            disabled={!this.props.canUndo}
          >
            Undo
          </button>
          <button
            className="redo"
            onClick={this.props.onRedo}
            disabled={!this.props.canRedo}
          >
            Redo
          </button>
        </div>

        <span>Undo Redo</span>
      </div>
    );
  }
}
// let UndoRedo = ({ canUndo, canRedo, onUndo, onRedo }) => (
//   <ul className="undoRedo ten-step">
//     <li>
//       <button className="undo" onClick={onUndo} disabled={!canUndo}>
//         Undo
//       </button>
//     </li>
//     <li>
//       <button className="redo" onClick={onRedo} disabled={!canRedo}>
//         Redo
//       </button>
//     </li>
//   </ul>
// );

const mapStateToProps = (state) => {
  return {
    canUndo: state.past.length > 0,
    canRedo: state.future.length > 0,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    clearHistory: () => dispatch(UndoActionCreators.clearHistory()),
    onUndo: () => dispatch(UndoActionCreators.undo()),
    onRedo: () => dispatch(UndoActionCreators.redo()),
  };
};

UndoRedo = connect(mapStateToProps, mapDispatchToProps)(UndoRedo);

export default UndoRedo;
